<template>
  <div>
    <v-btn icon color="yellow" @click="openDialog"
      ><v-icon>mdi-pencil</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Edit Batch Item Import"
          icon="mdi-package-variant"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-text-field
            outlined
            dense
            label="Batch Description *"
            v-model="form.batch_description"
            prepend-icon="mdi-list-box"
          ></v-text-field>
          <v-select
            outlined
            dense
            :items="suppliers"
            v-model="form.supplier_id"
            item-text="supplier_name"
            item-value="id"
            label="Supplier"
            prepend-icon="mdi-account-group"
          ></v-select>
          <v-text-field
            outlined
            dense
            label="Capital Amount"
            prepend-icon="mdi-cash"
            type="number"
            v-model="form.capital_amount"
          ></v-text-field>
          <div class="d-flex align-center mb-3">
            <p class="mr-2 mb-0">Date Ordered</p>
            <input type="date" v-model="form.date_ordered" />
          </div>
          <div class="d-flex align-center">
            <p class="mr-2 mb-0">Date Arrived</p>
            <input type="date" v-model="form.date_arrived" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="submit"
            :loading="loading"
            :disabled="loading"
            >Submit</v-btn
          >
          <v-btn @click="closeDialog" :disabled="loading">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        id: "",
        batch_description: "",
        supplier_id: "",
        capital_amount: "",
        date_ordered: "",
        date_arrived: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      suppliers: "supplier/suppliers",
    }),
  },
  methods: {
    ...mapActions({
      edit_import_batch: "importBatch/edit_import_batch",
    }),
    openDialog() {
      // Copy item data into a local form object to avoid mutating the prop
      this.form = {
        id: this.item.id,
        batch_description: this.item.batch_description || "",
        supplier_id: this.item.supplier_id || "",
        capital_amount: this.item.capital_amount || "",
        // Use raw date fields (YYYY-MM-DD) for the date input, not the formatted ones
        date_ordered: this.item.date_ordered_raw || "",
        date_arrived: this.item.date_arrived_raw || "",
      };
      this.dialog = true;
    },
    async submit() {
      if (!this.form.batch_description) {
        this.$alert({
          title: "Validation",
          message: "Batch Description is required.",
          color: "warning",
          icon: "mdi-alert",
        });
        return;
      }
      this.loading = true;
      try {
        let x = await this.$confirm({
          title: "Edit Batch Import",
          message: "Are you sure you want to proceed?",
          color: "primary",
          icon: "mdi-help-circle-outline",
        });
        if (x) {
          await this.edit_import_batch(this.form);
          this.$alert({
            title: "Success",
            message: "You have successfully edited a batch import",
            color: "success",
            icon: "mdi-check-circle",
          });
          this.dialog = false;
        }
      } catch (err) {
        // Error already shown by the store action
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
